import { cloneDeep } from 'lodash-es';

/** Deep-clone any value. */
export const clone = <T>(obj: T): T => cloneDeep(obj);

/** Return the first key in `obj` whose value strictly equals `value`. */
export const keyByValue = (
    obj: Record<string, unknown>,
    value: unknown,
): string | undefined => Object.keys(obj).find((key) => obj[key] === value);

/**
 * Immutably set a nested value by path. `keys` is consumed (shifted) as the
 * path is walked, matching the original util behaviour.
 */
export const updateByPath = (
    obj: Record<string, unknown>,
    keys: string[],
    value: unknown,
): Record<string, unknown> => {
    const key = keys.shift() as string;
    if (keys.length > 0) {
        const tmp = updateByPath(obj[key] as Record<string, unknown>, keys, value);
        return { ...obj, [key]: tmp };
    }
    return { ...obj, [key]: value };
};
